import { Component, NgZone, OnInit} from '@angular/core';
import { MatSnackBar } from '@angular/material';

/**
 * SnackbarComponent Componente que se encarga de mostrar una alerta desde cualquier vista.
 * @author Santiago V. <snippetdeveloper@gmail.com>
 * @copyright (c) 2019 Snippet Developer.
 */

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
})
export class SnackbarComponent implements OnInit {

  loading: any;
  text: string;
  constructor(private snackbar: MatSnackBar, private zone: NgZone) {}


  show(text = ''){
    if(!this.loading) {
      if (text) {
        this.text = text;
      } else {
        this.text = 'Cargando...';
      }

      this.snackbar.open(text, 'Cerrar', {
        duration: 10000,
      });
    }
  }

  ngOnInit() {
  }

}
